import dayjs from "dayjs";
import _ from "lodash/fp";
import React from "react";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import Select from "react-select";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import { RESULTS } from "../../common/constants/dropdownOptions";
import {
  alphanumeric,
  marksValidation,
  numberValidation,
  percentage
} from "../../common/constants/regex";
import { fromUTCDate, getFormattedDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import { getLookOptionsForADropdown } from "../../helpers/LookupOptionHelper";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/qualification.css";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";
import QualificationTypeDropdown from "./QualificationTypeDropdown";
import useQualificationActions from "./useQualificationActions";
const CertificationsQualification = ({ setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock, profileStatus }) => {

  let { profileCreationAllLookupData } = useSelector(
    (state) => state.profile,
    shallowEqual
  );

  const {
    handleQualificationChange,
    handleQualificationInfoSubmit,
    setActionType,
    setQualificationState,
    register,
    handleSubmit,
    errors,
    qualificationState,
    currentEditQualificationIndex,
    control,
    isResultDateMandatory,
    onQualificationNameChange,
    handleResultTypeChange,
    qualificationNames,
  } = useQualificationActions();

  const academicMonths = getLookOptionsForADropdown(
    "academic_month",
    profileCreationAllLookupData
  );

  const profileFormDetailsData = useSelector(
    (state) => state.profile.personalInfo
  );

  return (
    <form
      className="qualifcation_form"
      autoComplete="off"
      onSubmit={handleSubmit((e) => {
        handleQualificationInfoSubmit(e);
      })}
    >
      <div className="row">
        <QualificationTypeDropdown />
        {/** Following div is to displayed conditionally */}
        <div className="col-md-4 mb-3 mt-3 responsive-input-certi-name">
          <label className="float-start mb-0">
            {numberformat["4.2"]}&nbsp;
            {qualificationinformation.CERTIFICATION_NAME}
          </label>
          <span> {qualificationinformation_hindi.CERTIFICATION_NAME_hin} </span>
          <span className="redColor">*</span>{" "}
          {/* <select
            className="form-select bg-color"
            value={qualificationState.qualificationnamecode}
            name="qualificationnamecode"
            ref={register({ required: true })}
            onInput={onQualificationNameChange}
          >
            <option key={0} value="">
              {advertisementDetailsLabel.SELECT}
            </option>
            {qualificationNames
              .sort((name1, name2) => {
                return name1.qualificationName.localeCompare(
                  name2.qualificationName
                );
              })
              .map((ele, i) => {
                return (
                  <option key={i} value={ele.qualificationNameCode}>
                    {ele.qualificationName}
                  </option>
                );
              })}
          </select> */}
          <Select
            className="w-100 bg-color"
            name="qualificationnamecode"
            value={
              qualificationNames.find(
                (name) => name.qualificationNameCode === qualificationState.qualificationnamecode
              ) || null
            }
            getOptionValue={(option) => option.qualificationNameCode}
            getOptionLabel={(option) => option.qualificationName}
            onChange={(selectedOption) => {
              // Update qualification state
              setQualificationState((prevState) => ({
                ...prevState,
                qualificationnamecode: selectedOption?.qualificationNameCode || "",
              }));

              // Trigger onQualificationNameChange function
              onQualificationNameChange({
                target: { name: "qualificationnamecode", value: selectedOption?.qualificationNameCode || "" },
              });
            }}
            isSearchable={true} // Enables search functionality
            options={qualificationNames.sort((a, b) => a.qualificationName.localeCompare(b.qualificationName))}
          />
          {_.get("qualificationnamecode.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-certi-result">
          <label className="float-start mb-0">
            {numberformat["4.3"]}&nbsp;{qualificationinformation.RESULT}{" "}
          </label>
          <span> {qualificationinformation_hindi.RESULT_hin} </span>
          <span className="redColor">*</span>{" "}
          <select
            className="form-select bg-color"
            value={qualificationState.typeResult}
            name="typeResult"
            ref={register({ required: true })}
            onInput={handleResultTypeChange}
          >
            {RESULTS.map((ele, i) => {
              return (
                <option value={ele.value} key={i}>
                  {ele.label}
                </option>
              );
            })}
          </select>
          {_.get("typeResult.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-certi-result-date">
          <label className="float-start mb-0">
            {numberformat["4.4"]}&nbsp;{qualificationinformation.RESULT_DATE}
          </label>

          {isResultDateMandatory ? (
            <span>
              <span> {qualificationinformation_hindi.RESULT_DATE_hin} </span>
              <span className="redColor">*</span>
            </span>
          ) : (
            <span> {qualificationinformation_hindi.RESULT_DATE_hin} </span>
          )}

          <Controller
            name="resultDate"
            rules={{
              required: isResultDateMandatory,
              validate: (value) => {
                const dob = dayjs(profileFormDetailsData.dob).startOf("day").toDate();
                const selectedDate = dayjs(value).startOf("day").toDate();
                const today = dayjs().startOf("day").toDate();

                if (selectedDate <= dob) {
                  return "Result date must be after the date of birth.";
                }
                if (selectedDate > today) {
                  return "Result date cannot be in the future.";
                }
                return true;
              },
            }}
            key={qualificationState.resultDate ? "resultDate" : "resultDate1"}
            defaultValue={
              qualificationState.resultDate
                ? dayjs(getFormattedDate(qualificationState.resultDate)).toDate()
                : ""
            }
            control={control}
            render={({ onChange, value }) => (
              <DatePicker
                showIcon
                selected={
                  qualificationState.resultDate
                    ? dayjs(getFormattedDate(qualificationState.resultDate)).toDate()
                    : fromUTCDate(value)
                }
                minDate={dayjs(profileFormDetailsData.dob).add(1, "day").toDate()} // Ensure resultDate is greater than DOB
                maxDate={new Date()} // Cannot exceed today's date
                onChange={(e) => {
                  setQualificationState({
                    ...qualificationState,
                    resultDate: toUTCDate(e),
                  });
                  onChange(toUTCDate(e));
                }}
                onKeyDown={preventDateManualTyping}
                disabled={!isResultDateMandatory}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText={commonLabels.DATE_FORMAT}
                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                className="form-control bg-color"
                icon={
                  <img
                    src="/icons/calender.png"
                    className="date-picker-icon"
                    alt="date-icon"
                  />
                }
              />
            )}
          />
          {errors.resultDate && <p className="errorText">{errors.resultDate.message}</p>}

          {_.get("resultDate.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("resultDate.type", errors) === "validate" && (
            <p className="errorText">
              {qualificationinformation.DATA_LTE_TODAY_MSG}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-certi-grade">
          <label className="float-start mb-0">
            {numberformat["4.5"]}&nbsp;{qualificationinformation.GRADE}
          </label>
          <span> {qualificationinformation_hindi.GRADE_hin} </span>
          {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.certificationGrade}
            maxLength={3}
            name="certificationGrade"
            ref={register({
              required: isResultDateMandatory,
              pattern: alphanumeric,
            })}
            onInput={handleQualificationChange}

          />
          {_.get("certificationGrade.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("certificationGrade.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.ONLY_CHARATERS_NUMBERS}
            </p>
          )}
        </div>
        {/* --------------------------------------Start for Marks---------------------------------------------------- */}

        {isResultDateMandatory ? <div className="col-md-4 mb-3 mt-3 responsive-input-certi-obtain-Marks">
          <label className="float-start mb-0">
            {numberformat["4.6"]}&nbsp;
            {qualificationinformation.OBTAINED_MARKS}
            <span> {qualificationinformation_hindi.OBTAINED_MARKS_HIN} </span>
            {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={8}
            // value={
            //   qualificationState.obtainedMarks
            //     ? qualificationState.obtainedMarks
            //     : ""
            // }
            defaultValue={qualificationState.obtainedMarks}
            name="obtainedMarks"
            ref={register({
              required: true,
              pattern: marksValidation,
            })}
            onInput={handleQualificationChange}

          />
          {_.get("obtainedMarks.type", errors) === "required" &&
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>}
          {_.get("obtainedMarks.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_OBTAIN_MARKS_MESSAGE}
            </p>
          )}
        </div> : <div className="col-md-4 mb-3 mt-3 responsive-input-certi-obtain-Marks">
          <label className="float-start mb-0">
            {numberformat["4.6"]}&nbsp;
            {qualificationinformation.OBTAINED_MARKS}
            {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "}
            <span> {qualificationinformation_hindi.OBTAINED_MARKS_HIN} </span>
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={8}
            // value={
            //   qualificationState.obtainedMarks
            //     ? qualificationState.obtainedMarks
            //     : ""
            // }
            defaultValue={qualificationState.obtainedMarks}
            name="obtainedMarks"
            ref={register({
              // required: true,
              // pattern: marksValidation,
            })}
            onInput={handleQualificationChange}
            disabled
          />
          {/* {_.get("obtainedMarks.type", errors) === "required" &&
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>}
          {_.get("obtainedMarks.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_OBTAIN_MARKS_MESSAGE}
            </p>
          )} */}
        </div>}

        {isResultDateMandatory ? <div className="col-md-4 mb-3 mt-3 responsive-input-certi-total-Marks">
          <label className="float-start mb-0">
            {numberformat["4.7"]}&nbsp;
            {qualificationinformation.TOTAL_MARKS}
            <span> {qualificationinformation_hindi.TOTAL_MARKS_HIN} {" "} </span>
            {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={5}
            // value={
            //   qualificationState.totalMarks
            //     ? qualificationState.totalMarks
            //     : ""
            // }
            defaultValue={qualificationState.totalMarks}
            name="totalMarks"
            ref={register({
              required: true,
              pattern: numberValidation,
            })}
            onInput={handleQualificationChange}

          />
          {_.get("totalMarks.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("totalMarks.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_MARKS_MESSAGE}
            </p>
          )}
        </div>
          : <div className="col-md-4 mb-3 mt-3 responsive-input-certi-total-Marks">
            <label className="float-start mb-0">
              {numberformat["4.7"]}&nbsp;
              {qualificationinformation.TOTAL_MARKS}
              {isResultDateMandatory ? (
                <span className="redColor">*</span>
              ) : (
                ""
              )}{" "}
              <span> {qualificationinformation_hindi.TOTAL_MARKS_HIN} </span>
            </label>
            <input
              type="text"
              className="form-control bg-color text-uppercase"
              maxLength={8}
              // value={
              //   qualificationState.totalMarks
              //     ? qualificationState.totalMarks
              //     : ""
              // }
              defaultValue={qualificationState.totalMarks}
              name="totalMarks"
              ref={register({
                // pattern: marksValidation,
              })}
              onInput={handleQualificationChange}
              disabled
            />
            {/* {_.get("totalMarks.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("totalMarks.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_MARKS_MESSAGE}
            </p>
          )} */}
          </div>
        }

        {/* -------------------------------------------End for Marks--------------------------------------------- */}

        <div className="col-md-4 mb-3 responsive-input-certi-CGPA">
          <label className="float-start mb-0">
            {numberformat["4.8"]}&nbsp;
            {qualificationinformation.PERCENTAGE_GRADE}
            <span> {qualificationinformation_hindi.PERCENTAGE_GRADE_hin} </span>
            {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "}

          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={5}
            // value={
            //   qualificationState.percentageGrade
            //     ? qualificationState.percentageGrade
            //     : ""
            // }
            defaultValue={qualificationState.percentageGrade}
            name="percentageGrade"
            ref={register({
              required: isResultDateMandatory,
              pattern: percentage,
            })}
            onInput={handleQualificationChange}

          />
          {_.get("percentageGrade.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("percentageGrade.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_PERCENTAGE_MESSAGE}
            </p>
          )}
        </div>
        {/* <div className="col-md-4 mb-3 responsive-input-certi-duration">
          <label className="float-start mb-0">
            {numberformat["4.7"]}&nbsp;
            {qualificationinformation.COURSE_DURATION}
          </label>
          {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
          <span> {qualificationinformation_hindi.COURSE_DURATION_hin} </span>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            // value={
            //   qualificationState.courseDurationMonths
            //     ? qualificationState.courseDurationMonths
            //     : ""
            // }
            defaultValue={qualificationState.courseDurationMonths}
            maxLength={2}
            name="courseDurationMonths"
            ref={register({
              required: isResultDateMandatory,
              pattern: numberWithDecimal,
            })}
            onInput={handleQualificationChange}

          />
          {_.get("courseDurationMonths.type", errors) === "required" &&
            (isResultDateMandatory ? (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            ) : (
              ""
            ))}
          {_.get("courseDurationMonths.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_COURSE_DURATION_MESSAGE}
            </p>
          )}
        </div> */}
        <div className="col-md-4 mb-3 mt-3 responsive-input-certi-duration">
          <label className="float-start mb-0">
            {numberformat["4.9"]}&nbsp;
            {qualificationinformation.COURSE_DURATION}
          </label>
          <span> {qualificationinformation_hindi.COURSE_DURATION_hin} </span>
          {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
          <select
            className="form-select bg-color"
            value={qualificationState.courseDurationMonths}
            name="courseDurationMonths"
            ref={register({ required: isResultDateMandatory })}
            onInput={handleQualificationChange}
          >
            <option key={0} value="">
              {advertisementDetailsLabel.SELECT}
            </option>
            {academicMonths &&
              academicMonths
                .sort((month1, month2) => {
                  return month1.id - month2.id
                })
                .map((ele) => (
                  <option key={ele.id} value={ele.label}>
                    {ele.label}
                  </option>
                ))}
          </select>
          {_.get("courseDurationMonths.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="text-center mb-5 mt-5">
          {
            profileStatus !== true ? (
              <>
                {currentEditQualificationIndex !== -1 ? (
                  <button
                    type="submit"
                    name="edit"
                    className=" btn btn-primary custom_button  m-1  "
                    onClick={() => {
                      setActionType("edit");
                      setActiveQualificationIndex("");
                      setActiveIntershipIndex("");
                      setActivePublicationIndex("");
                    }}
                  >
                    {qualificationinformation.UPDATE}
                  </button>
                ) : (
                  <button
                    type="submit"
                    name="add"
                    className=" btn btn-primary custom_button  m-1  "
                    onClick={(e) => {
                      setActionType("add");
                    }}
                  >
                    {qualificationinformation.ADD}
                  </button>
                )}
              </>
            ) : (
              enableEditProfileWithLock?.editProfileWithLock == "1" ? (
                (() => {
                  const qualificationInfoList = enableEditProfileWithLock?.QualificationInfo?.split(",") || [];
                  const canCreate = qualificationInfoList.includes("C");
                  const canUpdate = qualificationInfoList.includes("U");

                  if (currentEditQualificationIndex !== -1 && canUpdate) {
                    return (
                      <button
                        type="submit"
                        name="edit"
                        className=" btn btn-primary custom_button  m-1  "
                        onClick={() => {
                          setActionType("edit");
                          setActiveQualificationIndex("");
                          setActiveIntershipIndex("");
                          setActivePublicationIndex("");
                        }}
                      >
                        {qualificationinformation.UPDATE}
                      </button>
                    );
                  } else if (canCreate) {
                    return (
                      <button
                        type="submit"
                        name="add"
                        className=" btn btn-primary custom_button  m-1  "
                        onClick={(e) => {
                          setActionType("add");
                        }}
                      >
                        {qualificationinformation.ADD}
                      </button>
                    );
                  }
                })()
              ) : ""
            )
          }

        </div>
      </div>
    </form>
  );
};
export default CertificationsQualification;
